import { useCallback, useEffect, useMemo, useSyncExternalStore } from 'react';
import {
  getNavigationSnapshot,
  parseNavigationSnapshot,
  refreshNavigation,
  subscribeNavigation,
} from '../services/navigationStore';

/*
 * NAV-ENTITLEMENTS01 (ТЗ v4 §31, FE-FIX14): навигация текущего пользователя.
 *
 * Сайдбар строится по ключам backend, а не по локальной роли. Данные и
 * visibilitychange принадлежат services/navigationStore: сколько бы компонентов
 * ни использовало хук, возврат вкладки из фона даёт один GET /me/navigation.
 * Ключи перезапрашиваются при монтировании (запросы склеиваются в один).
 *
 * Если эндпоинт недоступен (404/501 — backend без entitlements), keys = null,
 * что означает «ограничений нет»: спрятать всё меню из-за отсутствующего API
 * хуже, чем показать прежний набор. Скрытие пункта не защита — данные закрывает
 * backend.
 */
const noopSubscribe = () => () => {};
const idleSnapshot = () => 'idle|';

export const useNavigationEntitlements = ({ enabled = true } = {}) => {
  const snapshot = useSyncExternalStore(
    enabled ? subscribeNavigation : noopSubscribe,
    enabled ? getNavigationSnapshot : idleSnapshot,
  );

  useEffect(() => {
    if (enabled) refreshNavigation();
  }, [enabled]);

  const { status, keys } = useMemo(() => parseNavigationSnapshot(snapshot), [snapshot]);
  const reload = useCallback(() => { refreshNavigation(); }, []);

  return { keys: enabled ? keys : null, status: enabled ? status : 'idle', reload };
};

export default useNavigationEntitlements;
